import React, {useState} from 'react'
import axios from 'axios';
import {ReactComponent as Spinner} from '../../assets/oval.svg';
import ProcessVerification from './ProcessVerification'

export default function GenerateVerification(props) {
    const [values, setValues] = React.useState({
        email: '',
        mobile: '',
    });
    const [verificationCodeSent, setVerificationCodeSent] = useState(false);

    const handleChange = (property) => (event) => {
        let value = event.target.value
        let id = event.target.id;
        if(id === 'mobile' && !isNumber(value)) {
            return
        }
        singleErrorCheck(id, value);
        setValues({ ...values, [property]: value });
    };

    let errorStyle = (id, property, style) => {document.getElementById(`${id}`).style[property] = style}

    let errorTarget = (id, value) => {
        let errors = false;
        // let errorStyle = (style) => {document.getElementById(`${id}-container`).style.borderBottom = style}
        if(value.length < 1){
          errorStyle(`${id}-container`, 'border', '1px solid #ef4b4b')
          errors = true;
        } else if (id === 'email') {
          if(!emailValidation(value)) {
            errorStyle(`${id}-container`, 'border', '1px solid #5e76e8')
            // errorStyle('3px solid #5e76e8')
            errors = true;
          } else {
            errorStyle(`${id}-container`, 'border', '')
            // errorStyle('');
          }
        } else {
          errorStyle(`${id}-container`, 'border', '')
          // errorStyle('');
        }
        return errors;
    }

    const singleErrorCheck = (target, value) => {
        return errorTarget(target, value);
    }

    const emailValidation = (string) => {
        let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        
        if(string.match(mailFormat)){
            return true;
        } else {
            return false;
        }
    }

    const isNumber = (value) => {
        let validNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
        for(let i = 0; i < value.length; i++) {
            if(!validNumbers.includes(value[i])) {
            return false;
            }
        }
        return true;
    }

    const capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    const [verificationType, setVerificationType] = useState('email');
    let toggleVerificationType = () => {
        setVerificationType(verificationType === "mobile" ? 'email' : 'mobile');
        props.getData('verificationType', verificationType);
    }

    const [loading, setLoading] = useState(false);
    const sendRequest = () => {
        let tok =  btoa(`${props.unicycle}:${props.pencil}`);
        if(singleErrorCheck(verificationType, values[verificationType])){return}
        props.getData(verificationType, values[verificationType]);
        setLoading(true);
        let data = JSON.stringify({
            "orgId": props.orgId,
            "typeEmailOrMobile": verificationType,
            "typeRsvpOrCheckIn": props.urlParams,
            "email": values.email,
            "mobile": values.mobile
        })

        axios.post('https://api.churchpad.com/v3/rsvp-check-in-web-generate-verification-code/', data, {
            headers: { 
                'Authorization' : `Basic ${tok}`,
                'Content-Type': 'application/json',
            },
        }).then(res => {
            setVerificationCodeSent(true);
            setLoading(false);
        }).catch(err => {
            console.log(err);
        })
    }
    return (
        <>
            {!verificationCodeSent ? 
            <>
                <div className="icon-container" style={{backgroundColor:`${props.colors.background}f1`}}>
                    <div className="verification-header">
                        <div className="title"><h4>{props.urlParams === 'rsvp' ? (props.rsvpLabel).split('-').join(' ') : props.urlParams === 'checkin' ? 'Check In' : props.urlParams}</h4></div>
                        <span className="icon" style={{boxShadow: `0px 3px 3px ${props.colors.background}b3`}}>
                            <i className={`fas fa-${verificationType === 'mobile' ? 'mobile' : 'envelope'}`} style={{color: `${props.colors.background}f1`}}></i>
                        </span>
                        <div className="sub-header">
                            <h3>Enter your {verificationType === 'mobile' ? 'phone number' : 'email'} and we'll send you a verification code.</h3>
                        </div>
                    </div> 
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,64L40,58.7C80,53,160,43,240,64C320,85,400,139,480,170.7C560,203,640,213,720,202.7C800,192,880,160,960,170.7C1040,181,1120,235,1200,224C1280,213,1360,139,1400,101.3L1440,64L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path></svg>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,128L24,112C48,96,96,64,144,64C192,64,240,96,288,101.3C336,107,384,85,432,106.7C480,128,528,192,576,192C624,192,672,128,720,117.3C768,107,816,149,864,160C912,171,960,149,1008,128C1056,107,1104,85,1152,85.3C1200,85,1248,107,1296,106.7C1344,107,1392,85,1416,74.7L1440,64L1440,320L1416,320C1392,320,1344,320,1296,320C1248,320,1200,320,1152,320C1104,320,1056,320,1008,320C960,320,912,320,864,320C816,320,768,320,720,320C672,320,624,320,576,320C528,320,480,320,432,320C384,320,336,320,288,320C240,320,192,320,144,320C96,320,48,320,24,320L0,320Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,64L80,90.7C160,117,320,171,480,186.7C640,203,800,181,960,149.3C1120,117,1280,75,1360,53.3L1440,32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,288L80,288C160,288,320,288,480,256C640,224,800,160,960,133.3C1120,107,1280,117,1360,122.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill={`${props.colors.background}f1`} fillOpacity="1" d="M0,32L1440,320L1440,0L0,0Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,32L1440,320L1440,320L0,320Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,160L60,138.7C120,117,240,75,360,74.7C480,75,600,117,720,149.3C840,181,960,203,1080,186.7C1200,171,1320,117,1380,90.7L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg> */}
                </div>
                <div className="form-container">
                    <form className="col s12">
                        <div className="row">
                            <div className="input-field col s12" id={`${verificationType}-container`}>
                                <input id={verificationType} type="text" className="validate" onChange={handleChange(verificationType)} value={values[verificationType]}/>
                                <label htmlFor={verificationType}>{capitalize(verificationType)}</label>
                            </div>

                            <div className="switch-type waves-effect" onClick={toggleVerificationType}>
                                <h4>Or verify with {verificationType === 'mobile' ? 'email' : 'phone number'}  <i className={`las la-${verificationType === 'mobile' ? 'envelope' : 'mobile'}`}></i></h4>
                            </div>
                        </div>
                    </form>

                    <button className="waves-effect send-code" style={{backgroundColor: `${props.colors.background}f1`}} onClick={sendRequest}>
                        {loading ? <Spinner/> : <h4>Send code</h4>}
                    </button>
                </div>
            </>
            :
            <ProcessVerification
                colors={{...props.colors}}
                orgId={props.orgId}
                pencil={props.pencil}
                unicycle={props.unicycle}
                urlParams={props.urlParams}
                email={values.email}
                mobile={values.mobile}
                verificationType={verificationType}
            />}
        </>
    )
}
